var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-webview-none",
      attrs: { id: "mobile-details-advantages" },
    },
    [
      _vm.isAuthenticated
        ? [
            _c("h2", {
              staticClass: "no-signature lead fw-bold mb-0",
              domProps: { innerHTML: _vm._s(_vm.labels.loggedLabels.title) },
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "mb-0",
              domProps: { innerHTML: _vm._s(_vm.labels.loggedLabels.text) },
            }),
            _vm._v(" "),
            _c("ob1-liens", {
              attrs: {
                "with-arrow": true,
                text: _vm.labels.loggedLabels.linkLabel,
                "data-oevent-category": _vm.labels.loggedTmsDTO.tagZone,
                "data-oevent-action": _vm.labels.loggedTmsDTO.tagName,
                "data-oevent-label": _vm.labels.loggedTmsDTO.tagTarget,
                href: _vm.labels.href,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }